var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.04 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M.73 0a.79.79 0 01.54.22l13.57 13.26a.74.74 0 010 1L1.27 27.78a.77.77 0 01-1.07 0 .74.74 0 010-1L13.24 14 .2 1.26a.72.72 0 010-1A.72.72 0 01.73 0z",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS4wNCIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDE1LjA0IDI4Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIHN0cm9rZT0iY3VycmVudENvbG9yIiBkPSJNLjczLDBhLjc5Ljc5LDAsMCwxLC41NC4yMkwxNC44NCwxMy40OGEuNzQuNzQsMCwwLDEsMCwxTDEuMjcsMjcuNzhhLjc3Ljc3LDAsMCwxLTEuMDcsMCwuNzQuNzQsMCwwLDEsMC0xTDEzLjI0LDE0LC4yLDEuMjZhLjcyLjcyLDAsMCwxLDAtMUEuNzIuNzIsMCwwLDEsLjczLDBaIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4K";
export { SvgChevronRight as ReactComponent };